import { Heading, List, Stack, Text } from '@chakra-ui/react';

export const TCNL = () => {
  return (
    <div>
      <Heading as="h1" size="md" mt={4}>
        ALGEMENE VOORWAARDEN SUP SUP CLUB B.V.
      </Heading>
      <Text fontWeight="bold" mt={2}>
        SUP SUP CLUB B.V.
      </Text>
      <Text fontStyle="italic">(Versie februari 2026)</Text>
      <Stack gap={4} mt={4}>
        <Heading size="md">Artikel 1 – Definities</Heading>
        <Text fontWeight="bold">Sup Sup Club</Text>
        <Text>
          Sup Sup Club B.V., statutair gevestigd te Amsterdam en
          kantoorhoudende aan Herengracht 406, 1017 BX Amsterdam, ingeschreven
          bij de Kamer van Koophandel onder nummer 81205309.
        </Text>
        <Text fontWeight="bold">Website</Text>
        <Text>
          www.supsupclub.com of een andere door Sup Sup Club aangewezen website.
        </Text>
        <Text fontWeight="bold">Webapplicatie</Text>
        <Text>
          De digitale omgeving bereikbaar via onder meer app2.supsupclub.com of
          een andere door Sup Sup Club aangewezen URL, waarmee reserveringen
          worden gemaakt en lockers worden geopend.
        </Text>
        <Text fontWeight="bold">Klantenservice</Text>
        <Text>
          Bereikbaar via telefoonnummer 085-1309686, via e-mail
          info@supsupclub.com of via de in de Webapplicatie vermelde
          contactmogelijkheden.
        </Text>
        <Text fontWeight="bold">Station</Text>
        <Text>
          Een geautomatiseerd, onbemand verhuurstation waarin SUP-boards,
          toebehoren en lockers zich bevinden.
        </Text>
        <Text fontWeight="bold">Locker</Text>
        <Text>
          De afsluitbare compartimenten binnen het Station die via de
          Webapplicatie toegankelijk zijn.
        </Text>
        <Text fontWeight="bold">Self-Service Verhuur</Text>
        <Text>
          De geautomatiseerde verhuur van SUP-boards zonder fysieke
          aanwezigheid van personeel, toezicht of begeleiding op locatie.
        </Text>
        <Text fontWeight="bold">Deelnemer</Text>
        <Text>
          Iedere natuurlijke persoon die gebruik maakt van een via Sup Sup Club
          gereserveerd SUP-board of Locker.
        </Text>
        <Text fontWeight="bold">Boekende Deelnemer</Text>
        <Text>
          De natuurlijke persoon die één of meerdere SUP-boards reserveert via
          de Webapplicatie.
        </Text>
        <Text fontWeight="bold">Overeenkomst</Text>
        <Text>
          De overeenkomst tussen Sup Sup Club en Deelnemer tot tijdelijk gebruik
          van SUP-board, Locker en Station.
        </Text>

        <Heading size="md">
          Artikel 2 – Contractspartij &amp; Self-Service Model
        </Heading>
        <List.Root>
          <List.Item>
            De Overeenkomst wordt uitsluitend gesloten tussen Deelnemer en Sup
            Sup Club B.V.
          </List.Item>
          <List.Item>
            Eventuele franchisehouders, locatiehouders of andere betrokken
            partijen zijn geen contractspartij bij de Overeenkomst.
          </List.Item>
          <List.Item>
            Sup Sup Club is aanbieder van geautomatiseerde self-service
            watersportverhuur.
          </List.Item>
          <List.Item>
            In beginsel is bij het Station geen medewerker van Sup Sup Club,
            geen franchisehouder en geen locatiehouder fysiek aanwezig.
          </List.Item>
          <List.Item>
            Er is geen toezicht, geen begeleiding en geen reddingsdienst
            aanwezig.
          </List.Item>
          <List.Item>
            Deelnemer erkent uitdrukkelijk zelfstandig en zonder begeleiding
            gebruik te maken van het gehuurde materiaal.
          </List.Item>
        </List.Root>

        <Heading size="md">
          Artikel 3 – Totstandkoming &amp; Groepsreserveringen
        </Heading>
        <Text>De Overeenkomst komt tot stand zodra:</Text>
        <List.Root>
          <List.Item>via de Webapplicatie een reservering wordt gemaakt;</List.Item>
          <List.Item>deze Algemene Voorwaarden worden geaccepteerd;</List.Item>
          <List.Item>en betaling is voltooid.</List.Item>
        </List.Root>
        <Text>
          De Overeenkomst eindigt automatisch na afloop van de gereserveerde
          huurperiode.
        </Text>
        <Text>
          Indien de Boekende Deelnemer meerdere SUP-boards reserveert:
        </Text>
        <List.Root>
          <List.Item>
            verklaart hij/zij bevoegd te zijn namens alle medegebruikers de
            Overeenkomst aan te gaan;
          </List.Item>
          <List.Item>
            verklaart hij/zij dat alle medegebruikers kennis hebben genomen van
            deze Algemene Voorwaarden en hiermee instemmen;
          </List.Item>
          <List.Item>
            staat hij/zij ervoor in dat alle medegebruikers voldoen aan de
            deelnamevoorwaarden.
          </List.Item>
        </List.Root>
        <Text>
          De Boekende Deelnemer is hoofdelijk aansprakelijk voor schade
          veroorzaakt door de door hem/haar aangemelde medegebruikers.
        </Text>
        <Text>
          Iedere medegebruiker wordt afzonderlijk aangemerkt als Deelnemer in de
          zin van deze Algemene Voorwaarden.
        </Text>

        <Heading size="md">Artikel 4 – Deelnamevoorwaarden</Heading>
        <Text>
          De minimumleeftijd voor zelfstandig huren is 18 jaar.
        </Text>
        <Text>Deelnemer verklaart:</Text>
        <List.Root>
          <List.Item>
            in het bezit te zijn van minimaal zwemdiploma A of een buitenlands
            equivalent daarvan;
          </List.Item>
          <List.Item>
            zelfstandig in open water te kunnen zwemmen en zichzelf in
            veiligheid te kunnen brengen;
          </List.Item>
          <List.Item>fysiek in staat te zijn zelfstandig te suppen;</List.Item>
          <List.Item>
            geen gebruik te maken onder invloed van alcohol, drugs of andere
            middelen.
          </List.Item>
        </List.Root>
        <Text>
          Minderjarigen mogen uitsluitend gebruikmaken onder directe
          begeleiding van een volwassene van 18 jaar of ouder die eveneens
          beschikt over minimaal zwemdiploma A of een buitenlands equivalent.
        </Text>
        <Text>
          Sup Sup Club verstrekt geen zwemvesten bij self-service verhuur.
        </Text>
        <Text>
          Deelnemer erkent dat het ontbreken van een zwemvest deel uitmaakt van
          het self-service karakter van de verhuur en dat hij/zij hiervoor zelf
          verantwoordelijkheid draagt.
        </Text>
        <Text>
          Sup Sup Club behoudt zich het recht voor deelname zonder opgaaf van
          reden te weigeren.
        </Text>

        <Heading size="md">Artikel 5 – Risicoaanvaarding</Heading>
        <Text>
          Deelnemer erkent dat watersport, waaronder suppen, inherente
          risico&apos;s met zich meebrengt, waaronder maar niet beperkt tot:
        </Text>
        <List.Root>
          <List.Item>verdrinking;</List.Item>
          <List.Item>onderkoeling;</List.Item>
          <List.Item>stroming;</List.Item>
          <List.Item>botsingen;</List.Item>
          <List.Item>plotselinge weersveranderingen;</List.Item>
          <List.Item>lichamelijk letsel.</List.Item>
        </List.Root>
        <Text>Deelnemer erkent uitdrukkelijk dat:</Text>
        <List.Root>
          <List.Item>er geen fysieke begeleiding aanwezig is;</List.Item>
          <List.Item>er geen toezicht of reddingsdienst aanwezig is;</List.Item>
          <List.Item>geen zwemvest wordt verstrekt;</List.Item>
          <List.Item>
            hij/zij zelf verantwoordelijk is voor het beoordelen van
            weersomstandigheden, watercondities en eigen veiligheid.
          </List.Item>
        </List.Root>
        <Text>Gebruik geschiedt volledig voor eigen risico.</Text>

        <Heading size="md">
          Artikel 6 – Materiaal, Locker &amp; Zorgvuldig Gebruik
        </Heading>
        <List.Root>
          <List.Item>
            Deelnemer dient vóór gebruik zelfstandig te controleren of het
            SUP-board, toebehoren, de Locker en het Station zichtbaar gebreken
            vertonen.
          </List.Item>
          <List.Item>
            Deelnemer dient het SUP-board, de Locker en het Station zorgvuldig
            en overeenkomstig de aanwijzingen in de Webapplicatie en op het
            Station te gebruiken.
          </List.Item>
          <List.Item>
            Het openen en sluiten van de Locker geschiedt volledig voor eigen
            rekening en risico.
          </List.Item>
          <List.Item>
            Gebruik van de Locker geschiedt volledig op eigen risico.
          </List.Item>
          <List.Item>
            Sup Sup Club aanvaardt geen bewaarplicht (bewaarneming) ten aanzien
            van in de Locker geplaatste eigendommen.
          </List.Item>
          <List.Item>
            Sup Sup Club is niet aansprakelijk voor verlies, diefstal of
            beschadiging van eigendommen die in of bij de Locker worden
            achtergelaten.
          </List.Item>
          <List.Item>
            Deelnemer wordt uitdrukkelijk geadviseerd geen waardevolle spullen
            in de Locker achter te laten.
          </List.Item>
        </List.Root>
        <Text>Bij twijfel of een defect:</Text>
        <List.Root>
          <List.Item>mag het materiaal of de Locker niet worden gebruikt;</List.Item>
          <List.Item>
            dient onverwijld contact te worden opgenomen met Sup Sup Club via de
            Webapplicatie of Klantenservice.
          </List.Item>
        </List.Root>
        <Text>
          Sup Sup Club is bevoegd een Locker of Station onmiddellijk buiten
          gebruik te stellen indien veiligheid dit vereist.
        </Text>

        <Heading size="md">
          Artikel 7 – Prijzen, Wijziging &amp; Annulering
        </Heading>
        <Text>Betaling geschiedt vooraf via het digitale systeem.</Text>
        <Text>
          Deelnemer kan tot vier (4) uur vóór aanvang van de gereserveerde
          periode de reservering wijzigen naar een ander beschikbaar tijdstip,
          uitsluitend via de Webapplicatie en onder voorbehoud van
          beschikbaarheid.
        </Text>
        <Text>
          Wijziging van een reservering geeft geen recht op restitutie.
        </Text>
        <Text>
          Annulering door Deelnemer geeft geen recht op restitutie.
        </Text>
        <Text>
          Sup Sup Club mag een reservering annuleren of opschorten bij:
        </Text>
        <List.Root>
          <List.Item>extreme weersomstandigheden;</List.Item>
          <List.Item>veiligheidsrisico&apos;s;</List.Item>
          <List.Item>overheidsmaatregelen;</List.Item>
          <List.Item>technische storingen.</List.Item>
        </List.Root>
        <Text>
          In een dergelijk geval zal Sup Sup Club de Deelnemer eerst de
          mogelijkheid bieden om de reservering kosteloos te verplaatsen naar
          een ander beschikbaar tijdstip.
        </Text>
        <Text>
          Indien verplaatsing niet mogelijk is of door Deelnemer niet wordt
          geaccepteerd, wordt het betaalde bedrag gerestitueerd.
        </Text>
        <Text>
          Op grond van artikel 6:230p sub e Burgerlijk Wetboek is het wettelijke
          herroepingsrecht niet van toepassing, aangezien sprake is van een
          vrijetijdsactiviteit met een specifieke datum of periode van
          uitvoering.
        </Text>

        <Heading size="md">Artikel 8 – Aansprakelijkheid</Heading>
        <Text>
          Sup Sup Club is uitsluitend aansprakelijk indien sprake is van opzet
          of grove schuld van haar statutair bestuur.
        </Text>
        <Text>
          Iedere aansprakelijkheid is beperkt tot het bedrag dat onder de
          toepasselijke verzekering wordt uitgekeerd.
        </Text>
        <Text>Sup Sup Club is niet aansprakelijk voor:</Text>
        <List.Root>
          <List.Item>verdrinking;</List.Item>
          <List.Item>lichamelijk letsel;</List.Item>
          <List.Item>gevolgschade;</List.Item>
          <List.Item>verlies of diefstal van eigendommen;</List.Item>
          <List.Item>schade voortvloeiend uit weersomstandigheden;</List.Item>
          <List.Item>
            letsel ontstaan door gebruik van het Station of de Locker, tenzij
            sprake is van opzet of grove schuld.
          </List.Item>
        </List.Root>
        <Text>
          Gebruik van het SUP-board, de Locker en het Station geschiedt
          volledig voor eigen risico.
        </Text>
        <Text>
          De in dit artikel opgenomen beperkingen gelden mede ten gunste van
          franchisehouders, locatiehouders, medewerkers en hulppersonen van Sup
          Sup Club.
        </Text>
        <Text>
          Deelnemer vrijwaart Sup Sup Club voor aanspraken van derden
          voortvloeiend uit zijn/haar gebruik van het SUP-board, de Locker of
          het Station.
        </Text>

        <Heading size="md">Artikel 9 – Schade</Heading>
        <Text>Deelnemer is aansprakelijk voor schade aan:</Text>
        <List.Root>
          <List.Item>het SUP-board;</List.Item>
          <List.Item>toebehoren;</List.Item>
          <List.Item>de Locker;</List.Item>
          <List.Item>het Station;</List.Item>
        </List.Root>
        <Text>
          indien deze schade het gevolg is van nalatigheid, onoordeelkundig
          gebruik of opzettelijk handelen.
        </Text>

        <Heading size="md">Artikel 10 – Overmacht</Heading>
        <Text>
          Sup Sup Club is niet aansprakelijk voor tekortkomingen veroorzaakt
          door overmacht, waaronder maar niet beperkt tot extreme
          weersomstandigheden, natuurrampen, overheidsmaatregelen of storingen
          in betalings- of softwaresystemen.
        </Text>

        <Heading size="md">Artikel 11 – Persoonsgegevens</Heading>
        <Text>
          Persoonsgegevens worden verwerkt conform de Algemene Verordening
          Gegevensbescherming (AVG) en het privacybeleid van Sup Sup Club.
        </Text>

        <Heading size="md">Artikel 12 – Toepasselijk Recht</Heading>
        <List.Root>
          <List.Item>
            Op alle rechtsverhoudingen met Sup Sup Club is uitsluitend
            Nederlands recht van toepassing.
          </List.Item>
          <List.Item>
            Geschillen worden exclusief voorgelegd aan de bevoegde rechter te
            Amsterdam.
          </List.Item>
          <List.Item>
            In geval van tegenstrijdigheid tussen een Nederlandse en Engelse
            versie van deze Algemene Voorwaarden, prevaleert de Nederlandse
            versie.
          </List.Item>
        </List.Root>
      </Stack>
    </div>
  );
};
